import * as React from "react";

const ArrowNextTableIconSVG = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="41">
    <path
      fill="#171718"
      d="m15.888 30-1.775-1.775L22.338 20l-8.225-8.225L15.888 10l10 10z"
    ></path>
  </svg>
);

export default ArrowNextTableIconSVG;
